import React from 'react';

const StatCard = ({ icon: Icon, number, label }) => {
  return (
    <div className="stat-card reveal">
      <Icon className="stat-icon" size={24} />
      <div className="stat-content">
        <div className="stat-number">{number}</div>
        <div className="stat-label">{label}</div>
      </div>
    </div>
  );
};

export default StatCard;
